module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"label":"On/off microphone"},"es":{"label":"Activar/desactivar micrófono"}}')
  delete Component.options._Ctor
}
